import React, { useEffect, useState } from 'react';
import PlayerSilhouette from './PlayerSilhouette';

/**
 * Shared avatar for player chip/row/tile/popover: headshot photo, falling back to
 * a generic silhouette when the player has no photo.
 */
function PlayerAvatar({ player, size = 36, className = '', style = {} }) {
  const [imgError, setImgError] = useState(false);
  const photoUrl = player?.photoUrl || player?.headshotUrl || player?.image;

  useEffect(() => {
    setImgError(false);
  }, [player?.id, photoUrl]);

  const showPhoto = Boolean(photoUrl && !imgError);

  return (
    <span
      className={`p-avatar ${player ? '' : 'empty-ava'} ${className}`.trim()}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.32)), ...style }}
    >
      {player && showPhoto ? (
        <img src={photoUrl} alt="" onError={() => setImgError(true)} />
      ) : (
        player && <PlayerSilhouette />
      )}
    </span>
  );
}

export default PlayerAvatar;
